var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search-box"},[_c('van-search',{attrs:{"shape":"round","clearable":"","placeholder":_vm.placeholder,"left-icon":require('@/styles/img/icon_search.png'),"background":"transparent"},on:{"search":_vm.onSearch},model:{value:(_vm.sVal),callback:function ($$v) {_vm.sVal=$$v},expression:"sVal"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29f153d9","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchBar/index.vue
// module id = null
// module chunks = 